import { lazy } from 'react';

// Auth
export const Login = lazy(() => import('../pages/auth/Login'));
export const SignUp = lazy(() => import('../pages/auth/SignUp'));
export const ForgotPassword = lazy(() => import('../pages/auth/ForgotPassword'));
export const ResetPassword = lazy(() => import('../pages/auth/ResetPasswordNew'));
export const NewResetPassword = lazy(() => import('../pages/auth/NewResetPassword'));

// CupShup
export const CupShupDashboard = lazy(() => import('../pages/dashboard/CupShupDashboard'));
export const VendorList = lazy(() => import('../pages/vendors/VendorList'));
export const ClientList = lazy(() => import('../pages/client/ClientList'));
export const ActivityList = lazy(() => import('../pages/activities/ActivityList'));
export const ActivityDetail = lazy(() => import('../pages/activities/ActivityDetail'));
export const MappedActivities = lazy(() => import('../pages/activities/MappedActivities'));
export const MappedTasks = lazy(() => import('../pages/tasks/MappedTasks'));
export const InviteUser = lazy(() => import('../pages/invite/InviteUser'));
export const ActivityForm = lazy(() => import('../pages/activities/ActivityForm'));
export const OperationsDashboard = lazy(() => import('../pages/operations/OperationsDashboard'));

// Vendor
export const VendorDashboard = lazy(() => import('../pages/vendor/VendorDashboard'));
export const VendorActivityList = lazy(() => import('../pages/vendor/Activities'));
export const MyActivities = lazy(() => import('../pages/vendor/MyActivities'));
export const MyTasks = lazy(() => import('../pages/vendor/MyTasks'));
export const AddTask = lazy(() => import('../pages/vendor/AddTask'));
export const VendorActivityDetail = lazy(() => import('../pages/vendor/VendorActivityDetail'));

// Client
export const ClientDashboard = lazy(() => import('../pages/client/dashboard'));
export const ClientProfile = lazy(() => import('../pages/client/profile'));
export const BrandTasks = lazy(() => import('../pages/client/BrandTasks'));
export const ClientTasks = lazy(() => import('../pages/client/tasks'));
export const ClientActivities = lazy(() => import('../pages/client/activities'));
export const ClientActivitiesRedesigned = lazy(() => import('../pages/client/activities-redesigned'));
export const ClientAllTasks = lazy(() => import('../pages/client/all-tasks'));
export const ClientAITools = lazy(() => import('../pages/client/ai-tools'));
export const ClientAIAgents = lazy(() => import('../pages/client/ai-agents'));
export const ClientEmailCampaign = lazy(() => import('../pages/client/email-campaign'));
export const ClientWhatsAppCampaign = lazy(() => import('../pages/client/whatsapp-campaign'));
export const MediaPlanning = lazy(() => import('../pages/client/MediaPlanning'));
export const MyPlans = lazy(() => import('../components/client/media-planning/MyPlansNew'));

// Creative Studio
export const CreativeStudioLanding = lazy(() => import('../pages/client/creative-studio'));
export const CampaignListPage = lazy(() => import('../pages/client/creative-studio/CampaignListPage'));
export const CreateCampaignWizard = lazy(() => import('../pages/client/creative-studio/CreateCampaignWizard'));
export const CampaignDetailPage = lazy(() => import('../pages/client/creative-studio/CampaignDetailPage'));
export const CreativeDetailPage = lazy(() => import('../pages/client/creative-studio/CreativeDetailPage'));
export const ApprovalInboxPage = lazy(() => import('../pages/client/creative-studio/ApprovalInboxPage'));
export const BrandGuidelinesSetupPage = lazy(() => import('../pages/client/creative-studio/BrandGuidelinesSetupPage'));
export const RenderTestPage = lazy(() => import('../pages/client/creative-studio/RenderTestPage'));

// Common
export const TodoPage = lazy(() => import('../pages/todo'));
export const Profile = lazy(() => import('../pages/profile/Profile'));
export const Settings = lazy(() => import('../pages/settings/Settings'));

// Add the new page
export const NewPaymentRequestPage = lazy(() => import('../pages/PaymentRequests/NewPaymentRequestPage'));

// Add the new My Requests page
export const MyRequestsPage = lazy(() => import('../pages/PaymentRequests/MyRequestsPage'));

// Add the Submitted Requests page - RENAME to ReviewRequestsPage
export const ReviewRequestsPage = lazy(() => import('../pages/PaymentRequests/ReviewRequestsPage'));
export const RequestDetailPage = lazy(() => import('../pages/PaymentRequests/RequestDetailPage'));

// Automations
export const AutomationsPage = lazy(() => import('../pages/automations/AutomationsPage'));
export const PersonalizedContentPage = lazy(() => import('../pages/automations/PersonalizedContentPage'));
export const NewsAnalyzerPage = lazy(() => import('../pages/automations/NewsAnalyzerPage'));
export const LegacySEOAuditPage = lazy(() => import('../pages/automations/SEOAuditPage'));
export const KeywordResearchPage = lazy(() => import('../pages/automations/KeywordResearchPage'));

// SEO Audit (New DataforSEO-based)
export const SEOAuditPage = lazy(() => import('../pages/seo/SEOAuditPage'));

// P&L Dashboard
export const PLDashboard = lazy(() => import('../pages/pl/PLDashboard'));

export const VendorProfile = lazy(() => import('../pages/vendor/profile'));
export const VendorProfileView = lazy(() => import('../pages/cupshup/VendorProfileView'));
export const CupShupProfile = lazy(() => import('../pages/cupshup/profile'));

// HRMS
export const ManagerCorrectionsDashboard = lazy(() => import('../pages/ManagerCorrectionsDashboard').then(module => ({ default: module.ManagerCorrectionsDashboard })));
export const HRMSPage = lazy(() => import('../pages/cupshup/HRMSPage'));

// Invoicing
export const InvoicingPage = lazy(() => import('../pages/cupshup/InvoicingPage'));
export const InvoiceDashboard = lazy(() => import('../pages/invoicing/InvoiceDashboard'));

// SEO
export const SEOPage = lazy(() => import('../pages/seo/SEOPage'));
export const BlogWritingService = lazy(() => import('../pages/seo/BlogWritingService'));

// Client Blog Portal
export const ClientBlogDashboard = lazy(() => import('../pages/client/BlogDashboard'));
export const ClientBlogRequestForm = lazy(() => import('../pages/client/BlogRequestForm'));
export const ClientBlogReviewPage = lazy(() => import('../pages/client/BlogReviewPage'));